<template>
  <div>
    <!-- INICIO FORMULARIO -->
    <form role="form" @submit.stop.prevent="onSubmit">
      <div class="vx-row">
        <div class="vx-col mb-6">
          <span>Ativo</span>
          <vs-switch
            color="success"
            v-model="formMotivo.status"
            style="width: 60px"
          >
            <span slot="on">Ativo</span>
            <span slot="off">Inativo</span>
          </vs-switch>
        </div>
      </div>
      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <span>Nome</span>
          <vs-input
            size="large"
            class="w-full"
            name="Nome do Motivo"
            id="Nome do Motivo"
            v-model="formMotivo.nomeMotivo"
            v-validate="{ required: true }"
            :state="
              validateState(this.veeFields, this.veeErrors, 'Nome do Motivo')
            "
            :class="
              validateClass(this.veeFields, this.veeErrors, 'Nome do Motivo')
            "
          />
        </div>
      </div>
      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <span>Integração Tipo Sinistro Cilia</span>
          <v-select
            :options="sinistrosCilia"
            v-model="formMotivo.idCiliaTipoSinistro"
            :reduce="(item) => item.id"
            name="Integração Sinistro Cilia"
            id="Integração Sinistro Cilia"
            v-validate="{ required: true }"
            :state="
              validateState(
                this.veeFields,
                this.veeErrors,
                'Integração Sinistro Cilia',
              )
            "
            :class="
              validateClass(
                this.veeFields,
                this.veeErrors,
                'Integração Sinistro Cilia',
              )
            "
          >
          </v-select>
        </div>
      </div>
      <!-- INICIO ALERT -->
      <vs-alert
        v-if="$validator.errors.all().length > 0"
        color="danger"
        title="Atenção!!"
        active="true"
        class="my-3"
        style="height: auto !important"
      >
        <ul>
          <li
            class="mb-2"
            v-for="error in $validator.errors.all()"
            :key="error.id"
          >
            {{ error }}
          </li>
        </ul>
      </vs-alert>
      <!-- FIM ALERT -->
      <!-- INICIO BOTÕES -->
      <div class="vx-row">
        <div class="vx-col w-full text-right mt-5">
          <vs-button
            color="warning"
            type="border"
            class="mr-3 mb-2"
            @click.stop.prevent="onReset"
            >Cancelar</vs-button
          >
          <BotaoSubmit
            variant="success"
            :edit="dados.idMotivo ? true : false"
            :aguarde="aguardeCadastro"
            reference="BtnEditar"
          ></BotaoSubmit>
        </div>
      </div>
      <!-- FIM BOTÕES -->
    </form>
    <!-- FIM FORMULARIO -->
  </div>
</template>
<script>
import BotaoSubmit from '../../../../components/BotaoSubmit';
import functions from '../../../../utils/functions.js';
import locale from '../../../../locale.js';
import notify from '../../../../utils/notify.js';
import utils from '../../../../utils/list/';
import utilslocal from '../utils/';
import vSelect from 'vue-select';

export default {
  components: {
    BotaoSubmit,
    'v-select': vSelect,
  },
  props: {
    sideBar: {
      type: Boolean,
    },
    dados: {
      type: Object,
    },
  },
  data() {
    return {
      aguardeCadastro: false,
      sinistrosCilia: [],
      formMotivo: {
        idMotivo: null,
        status: false,
        nomeMotivo: '',
        idCiliaTipoSinistro: null,
      },
      validateClass: utils.validateStateClass,
      validateState: utils.validateState,
    };
  },
  watch: {
    dados() {
      this.preencheForm(this.dados);
    },
  },
  methods: {
    preencheForm(dados) {
      const motivo = this.verificaMotivo(dados);
      if (motivo) {
        this.formMotivo = {
          idMotivo: dados.idMotivo,
          status: dados.deletedAt ? false : true,
          nomeMotivo: dados.nomeMotivo,
          idCiliaTipoSinistro: dados.idCiliaTipoSinistro,
        };
      } else {
        this.formMotivo = {
          idMotivo: null,
          status: false,
          nomeMotivo: '',
          idCiliaTipoSinistro: null,
        };
      }
    },
    verificaMotivo(dados) {
      return 'idMotivo' in dados && 'nomeMotivo' in dados;
    },
    async preencheSinistrosCilia() {
      try {
        this.$vs.loading();
        this.sinistrosCilia = await functions.buscaDadosSelects(
          'domDeParaCiliaTiposSinistro',
          [],
          'nomeCiliaTipoSinistro',
          'idCiliaTipoSinistro',
        );
      } catch (error) {
        notify.notifyFail(this.$vs, error);
      } finally {
        this.$vs.loading.close();
      }
    },
    async onSubmit() {
      const formValidado = await this.$validator.validateAll();
      if (formValidado) {
        try {
          this.$vs.loading();

          if (this.formMotivo.idMotivo) {
            await utilslocal.atualizarMotivos([
              this.converterAtivacao(this.formMotivo),
            ]);
          } else {
            await utilslocal.criarMotivos(
              this.converterAtivacao(this.formMotivo),
            );
          }

          this.resetForm();
          notify.notifySuccess(this.$vs, 'Operação realizada com sucesso');
          this.$emit('concluido');
        } catch (error) {
          notify.notifyFail(this.$vs, error);
        } finally {
          this.$vs.loading.close();
        }
      }
    },
    converterAtivacao(motivo) {
      return { ...motivo, deletedAt: motivo.status ? null : new Date() };
    },
    onReset(evt) {
      evt.preventDefault();
      this.resetForm();
      this.$nextTick(() => {
        this.show = true;
      });
      this.$emit('cancel');
    },
    resetForm() {
      this.formMotivo = {
        idMotivo: null,
        status: false,
        nomeMotivo: '',
      };
    },
  },
  mounted() {
    this.$validator.localize('ptBr', locale);
    this.preencheSinistrosCilia();
  },
};
</script>
<style>
.input-group-color {
  display: flex !important;
  gap: 5px;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: center;
}

.color-picker {
  max-width: 2.5rem;
  height: 2.375rem;
  border: 1px solid rgba(60, 60, 60, 0.26);
  border-radius: 4px;
}
</style>
